export const OOBE_NS = "OOBE";

export interface OobeState {
  step?: number;
}
